// extracted by mini-css-extract-plugin
export default {"header":"header__3YKgi","logo":"logo__Q3ZIu","navBtn":"navBtn__QwRts","active":"active__Yg9yU","skipContent":"skipContent__QzQqF"};